import { render, staticRenderFns } from "./ApproveTabs.vue?vue&type=template&id=30ee199e&scoped=true"
import script from "./ApproveTabs.vue?vue&type=script&lang=js"
export * from "./ApproveTabs.vue?vue&type=script&lang=js"
import style0 from "./ApproveTabs.vue?vue&type=style&index=0&id=30ee199e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ee199e",
  null
  
)

export default component.exports